// This icon file is generated automatically.
var AsteriskOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.75 8.5l6.07-4.55a.73.73 0 011.04.17c.24.35.17.83-.17 1.07L11.27 10l6.42 4.8c.34.25.41.73.17 1.08a.73.73 0 01-1.04.17l-6.07-4.54v7.72c0 .43-.34.77-.75.77a.76.76 0 01-.75-.77v-7.72l-6.07 4.54a.73.73 0 01-1.04-.17.78.78 0 01.17-1.07L8.73 10 2.31 5.2a.78.78 0 01-.17-1.08.73.73 0 011.04-.17L9.25 8.5V.77C9.25.34 9.6 0 10 0s.75.34.75.77v7.72z" } }] }, "name": "asterisk", "theme": "outlined" };
export default AsteriskOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/AsteriskOutlined.js
// module id = 2024
// module chunks = 0